/*!
 * picker-custom.js
 * (c) 2024 Klonbits, Inc.
 * All rights reserved.
 */

var lang = document.querySelector('html').lang;
var jsFormat = lang != 'en' ? 'DD.MM.YYYY' : 'MM.DD.YYYY';
var dictValues = {
	en: {
		chin: 'Check-in ',
		chout: 'Check-out ',
		days: ['Monday', 'Thursday', ''],
	},
	tr: {
		chin: 'Giriş ',
		chout: 'Çıkış ',
		days: ['Pazartesi', 'Salı', 'Çarşamba', 'Perşembe', 'Cuma', 'Cumartesi', 'Pazar'],
	},
};

$(function () {
	$('.datepickers').each(function () {
		var $this = $(this);
		var ww = $(window).outerWidth();
		var isSingleDatepicker = $this.hasClass('datepickers--single');

		var yearSelectVal = false;

		var isChildpicker = $this.hasClass('childpicker');
		var momentYear = moment().get('year');

		if (isSingleDatepicker && isChildpicker) {
			yearSelectVal = [momentYear - 17, momentYear];
		} else if (isSingleDatepicker) {
			yearSelectVal = [1950, momentYear];
		}

		var config = {
			startDate: isSingleDatepicker ? false : moment(new Date()).format(jsFormat),
			singleMonth: isSingleDatepicker,
			singleDate: isSingleDatepicker,
			monthSelect: isSingleDatepicker,
			yearSelect: yearSelectVal,
			autoClose: true,
			format: jsFormat,
			language: lang,
			inline: ww < 768 ? (isSingleDatepicker ? false : true) : false,
			startOfWeek: 'monday',
			container: $this.closest('[class*=col]'),
			customArrowPrevSymbol: ' ',
			customArrowNextSymbol: ' ',
			ignoreReadonly: true,
			separator: ' - ',
			stickyMonths: true,
			customOpenAnimation: function (cb) {
				$(this).fadeIn(300, cb);
			},
			customCloseAnimation: function (cb) {
				$(this).fadeOut(300, cb);
			},
			setValue: function (s) {
				if ($(this).attr('readonly') || (!$(this).is(':disabled') && s != $(this).val())) {
					$(this).val(s);
					$this.parent().addClass('has-value');

					if (s.includes('-')) {
						$(this).parent().find('#inpCheckinDate').val(s.split('-')[0].trim());
						$(this).parent().find('#inpCheckoutDate').val(s.split('-')[1].trim());
					}
				}
			},
		};

		$this.dateRangePicker(config);

		console.debug(`dateRangePicker:::init`, $this, config)

		$this.bind('datepicker-open', function (ev, obj) {
			if (!isSingleDatepicker) {
				var $datepickerWrapper = $(obj.relatedTarget);

				$datepickerWrapper.find('.month-wrapper table').each(function () {
					var isCheckIn = $(this).hasClass('month1');
					var titleClass = isCheckIn ? 'checkin-title' : 'checkout-title';

					var dates = isCheckIn ? $datepickerWrapper.find('.start-day').text() : $datepickerWrapper.find('.end-day').text();

					var title = `<tr class="dates-caption">
																			<th colspan="7">
																				<h4 class="${isCheckIn ? 'checkin' : 'checkout'}-title text-left">
																					${isCheckIn ? dictValues[lang].chin : dictValues[lang].chout} <span class='font-weight-normal ml-2'>${dates != '...' ? dates : ''}</span>
																				</h4>
																			</th>
																		</tr>`;

					$(this)
						.find('thead .caption')
						.each(function () {
							$(this).prev().remove();
							//$(title).insertBefore($(this));
						});
				});
			}
		});

		//#region Deprecated Feature Fix - Use `MutationObserver` instead of `DOMSubtreeModified`

		// $('.date-picker-wrapper').each(function () {
		// 	$(this)
		// 		.find('.normal-top .start-day')
		// 		.on('DOMSubtreeModified', function () {
		// 			$('.checkin-title').html(dictValues[lang].chin + "<span class='font-weight-normal ml-2'>" + $(this).text() + '</span>');
		// 		});

		// 	$(this)
		// 		.find('.normal-top .end-day')
		// 		.on('DOMSubtreeModified', function () {
		// 			$('.checkout-title').html(dictValues[lang].chout + "<span class='font-weight-normal ml-2'>" + $(this).text() + '</span>');
		// 		});
		// });

		/** [Deprecation] Listener added for a synchronous 'DOMSubtreeModified' DOM Mutation Event.
		 * 	This event type is deprecated (https://w3c.github.io/uievents/#legacy-event-types) and work is underway to remove it from this browser.
		 * 	Usage of this event listener will cause performance issues today, and represents a risk of future incompatibility.
		 * 	Consider using MutationObserver instead.
		 */

		// Create a MutationObserver
		var observer = new MutationObserver(function (mutations) {
			mutations.forEach(function (mutation) {
				// Code to run when a DOM change occurs goes here
				if (mutation.target.classList.contains('start-day')) {
					$('.checkin-title').html(dictValues[lang].chin + "<span class='font-weight-normal ml-2'>" + $(mutation.target).text() + '</span>');
				} else if (mutation.target.classList.contains('end-day')) {
					$('.checkout-title').html(dictValues[lang].chout + "<span class='font-weight-normal ml-2'>" + $(mutation.target).text() + '</span>');
				}
			});
		});

		// Iterate through all '.date-picker-wrapper' elements to start monitoring
		$('.date-picker-wrapper').each(function () {
			var startDay = $(this).find('.normal-top .start-day')[0];
			var endDay = $(this).find('.normal-top .end-day')[0];

			// Start observing
			if (startDay) { observer.observe(startDay, { childList: true }); }
			if (endDay) { observer.observe(endDay, { childList: true }); }
		});

		//#endregion



	});

});
